<nz-table
  class="surprise-grid"
  #nzTable
  #expandTable
  [nzData]="listOfMapData"
  [nzPageSize]="listOfMapData.length"
  [nzShowPagination]="false"
  [nzScroll]="gridScrollValue"
  [nzLoading]="loading"
  *ngIf="showGrid"
>
  <thead>
    <tr>
      <th
        *ngFor="let data of gridHeader.level1; index as i"
        [attr.rowspan]="data.rowspan"
        [attr.colspan]="data.colspan"
        [nzWidth]="data.width"
        [ngClass]="{
          'border-right': data.borderRight,
          'border-right-dotted': data.borderRightDotted
        }"
        [nzLeft]="data.nzLeft"
        [class.lineitem-column-collapsed]="i === 0 && !lineItemHeadersExpanded"
        [class.last-period]="i === gridHeader.level1.length - 1"
        [nzAlign]="data.align"
      >
        <span
          *ngIf="i === 0"
          class="line-item-header-expansion"
          (click)="onLineItemColumnCollapse()"
        >
          <img
            *ngIf="lineItemHeadersExpanded"
            [src]="assetsUrl + '/collapse.png'"
            alt=""
          />
          <img
            *ngIf="!lineItemHeadersExpanded"
            [src]="assetsUrl + '/expand.png'"
            alt=""
          />
        </span>
        {{ data.label }}
      </th>
    </tr>
    <tr>
      <th
        *ngFor="let data of gridHeader.level2; index as i"
        [nzWidth]="data.width"
        [ngClass]="{
          'border-right': data.borderRight,
          'border-right-dotted': data.borderRightDotted,
          'value-header': data.valueHeader,
          'hide-cell': data.width === '0px'
        }"
        [nzAlign]="data.align"
        nz-popover
        nzPopoverPlacement="bottom"
        [nzPopoverContent]="
          data.label === 'Surprise'
            ? null
            : 'Updated: ' + popOverMapping[data.popoverKey]
        "
      >
        {{ data.label }}
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let data of expandTable.data">
      <ng-container *ngFor="let item of mapOfExpandedData[data.key]">
        <tr
          *ngIf="(item.parent && item.parent.expand) || !item.parent"
          [hidden]="item.hidden"
          [ngClass]="{ 'blank-row': item.header === true && item.name === ' ' }"
        >
          <!-- lineitem name / tab name column -->
          <td
            [nzIndentSize]="item.level * 1"
            [nzShowExpand]="!!item.children && !item.isExpandableRow"
            [(nzExpand)]="item.expand"
            (nzExpandChange)="
              collapse(mapOfExpandedData[data.key], item, $event)
            "
            [nzLeft]="'0px'"
            [ngClass]="{
              'expanded-name': item.isExpandableRow && item.expand,
              'border-right-dotted': !item.isTabRow && !item.header,
              'tab-cell': item.isTabRow || item.header
            }"
            [class.hide-cell]="!item.name"
            [attr.rowspan]="
              !item.isTabRow && item.expand ? selectedSourceList.length + 1 : 1
            "
            [class.lineitem-column-collapsed]="!lineItemHeadersExpanded"
          >
          <div class="lineitem-td-container">
            <span class="lineitem-name" *ngIf="item.header">{{
              item.name
            }}</span>
            <span class="lineitem-name" *ngIf="item.isTabRow"
              >{{ item.name
              }}<span *ngIf="tabLineCountMapping[item.name] !== ''"
                >({{ tabLineCountMapping[item.name] }})</span
              ></span
            >
            <span
              class="lineitem-name"
              *ngIf="!item.isTabRow && !item.header && item.children"
              >{{ item.name
              }}<span *ngIf="item.parameter_unit !== ''">{{
                item.parameter_unit
              }}</span></span
            >
          </div> 
          </td>
          <!-- bar chart column -->
          <td
            [nzLeft]="lineItemHeadersExpanded ? '300px' : '190px'"
            [ngClass]="{
              'border-right-dotted': !item.isTabRow && !item.header
            }"
            (click)="showChartPopup(item, 'surprise')"
          >
            <va-icon
              size="small"
              name="chart-bar"
              *ngIf="!item.isTabRow && !item.header"
              class="chart-icon"
            ></va-icon>
          </td>
          <!-- source column -->
          <td
            [nzLeft]="lineItemHeadersExpanded ? '330px' : '220px'"
            [nzShowExpand]="!!item.children && item.isExpandableRow"
            [(nzExpand)]="item.expand"
            (nzExpandChange)="
              collapse(mapOfExpandedData[data.key], item, $event)
            "
            [ngClass]="{ 'border-right': !item.isTabRow && !item.header }"
            class="left-align"
          >
            <span
              [ngClass]="{
                'broker-value':
                  !item.isExpandableRow && !item.header && !item.isTabRow
              }"
              class="source-value"
            >
              <span class="excluded-icon-container">
                <img
                  *ngIf="item.level > 1 && isSourceExcluded[item.source]"
                  [src]="assetsUrl + '/icon-excluded.png'"
                  alt=""
                />
              </span>
              {{ item.source }}
            </span>
          </td>

          <!-- values columns -->
          <ng-container *ngIf="!item.isTabRow && !item.header === true">
            <ng-container *ngFor="let period of surpriseMeta.periods; let lastPeriod = last;">
              <td
                *ngFor="let column of ['preq', 'va-actuals', 'surprise']; let lastS = last;"
                [ngClass]="{
                  'last-td': lastS && lastPeriod,
                  'border-right-dotted': !item.isTabRow,
                  'highlight-green':
                    column === 'surprise' && item['highlight-green-' + period],
                  'highlight-red':
                    column === 'surprise' && item['highlight-red-' + period],
                  'highlight-background':
                    highlightBackground !== '' &&
                    highlightBackground ===
                      item[column + '-dpid-' + period] + column + item.source
                }"
                class="right-align value-cell"
                (click)="setDPParams(item, period, column)"
                [class.hide-cell]="
                  gridFilters.onlySurprise && column !== 'surprise'
                "
              >
                <!-- {{ item[column + "-" + period] }} -->
                <app-value-renderer
                  [value]="item[column + '-' + period]"
                  [precision]="item.precision ? item.precision : 2"
                  [cut]="''"
                  [unit]="
                    column === 'surprise'
                      ? item['unit-' + period]
                        ? item['unit-' + period] === '%'
                          ? 'bps'
                          : '%'
                        : ''
                      : ''
                  "
                >
                </app-value-renderer>
              </td>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="item.isTabRow || item.header === true">
            <!-- handling for tab rows -->
            <ng-container
              *ngFor="let col of gridFilters.onlySurprise ? [1] : [1, 2, 3]"
            >
              <td *ngFor="let period of surpriseMeta.periods"></td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</nz-table>

<app-chart-popup
  [chartType]="chartPopupType"
  [dataToUse]="chartPopupDataToUse"
  [(showPopup)]="chartPopupVisible"
  (closePopup)="hideChartPopup()"
  [beginningStateReferrer]="beginningStateReferrer"
  [closeFeature]="feature"
></app-chart-popup>
